<template>
  <div ref="Boyocontent"
       v-loading="loading"
       :element-loading-text="loadingText"
       class="Boyo-content"
       style="padding-top:10px">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BoyoContent',
  props: {
    visible: Number,
    loading: Boolean,
    loadingText:''
  },
  data () {
    return {
    }
  },
  watch: {
    visible (val) {
      // let screenWidth = document.body.clientWidth//网页可见区域高
      // if (screenWidth <= 960) {
      //   this.$refs.Boyocontent.style['min-height'] = this.$refs.Boyocontent.style.cssText === 'min-height: 89%;' ? '97%' : '89%'
      // } else {
      //   this.$refs.Boyocontent.style['min-height'] = this.$refs.Boyocontent.style.cssText === 'min-height: 96.9%;' ? '89%' : '96.9%'
      // }
    }
  },
  mounted(){
      // console.log(document.body.clientHeight, this.$refs.Boyocontent.offsetTop)
      if(document.body.clientHeight && this.$refs.Boyocontent.offsetTop){
        this.$refs.Boyocontent.style['height'] = document.body.clientHeight - this.$refs.Boyocontent.offsetTop - 140 + 'px'
      }else{
        this.$refs.Boyocontent.style['height'] = '85%'
      }
  },
  methods: {}
}
</script>
<style lang="stylus" scoped>
.heade
  position fixed
  z-index 100
  width 100%
</style>



// WEBPACK FOOTER //
// src/components/BoyoContent/index.vue